/* eslint-disable react/forbid-prop-types,no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styled from 'styled-components';
import { media } from 'designsystem/index';
import ds from 'designsystem';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const StyledSlider = styled(Slider)`
  width: 100%;
  margin: ${(({ blogArticle }) => (blogArticle ? `${ds.get('metrics.l')} auto` : ''))};

  ${({ noMarginBottom }) => (noMarginBottom ? '.slick-list { margin-bottom: 0; }' : '')}
  
  ${({ cursorDefault }) => (cursorDefault ? 'cursor: default' : '')}

  ${({ selectable }) => (selectable ? `
     user-select: text;
     & .slick-slide {
        user-select: text;
      }
  ` : '')}

  ${media.tablet`
    ${({ threeColumnCarousel }) => (!threeColumnCarousel ? `
      cursor: move;
      cursor: grab;
    ` : '')}
      ${({ cursorDefault }) => (cursorDefault ? 'cursor: default' : '')}
  `}
  
  ${media.desktop`
    ${({ threeColumnCarousel }) => (threeColumnCarousel ? `
      & .slick-slide {
        margin-right: 7.3%;
        user-select: text;
      }
    ` : '')};
    ${({ cursorDefault }) => (cursorDefault ? 'cursor: default' : '')}
  `}
`;

const defaultSettings = {
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
};

const Carousel = (props) => {
  const {
    settings,
    children,
    threeColumnCarousel,
    blogArticle,
    cursorDefault,
    innerRef,
    selectable,
    noMarginBottom,
  } = props;
  const sliderSettings = Object.assign(defaultSettings, settings);

  return (
    <StyledSlider
      {...sliderSettings}
      selectable={selectable}
      innerRef={slider => innerRef && innerRef(slider)}
      cursorDefault={cursorDefault}
      threeColumnCarousel={threeColumnCarousel}
      blogArticle={blogArticle}
      noMarginBottom={noMarginBottom}
    >
      {children}
    </StyledSlider>
  );
};

Carousel.propTypes = {
  settings: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  threeColumnCarousel: PropTypes.bool,
  blogArticle: PropTypes.bool,
  cursorDefault: PropTypes.bool,
  selectable: PropTypes.bool,
  noMarginBottom: PropTypes.bool,
  innerRef: PropTypes.func,
};
Carousel.defaultProps = {
  threeColumnCarousel: false,
  blogArticle: false,
  cursorDefault: false,
  selectable: false,
  noMarginBottom: false,
  innerRef: null,
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/blocks/Carousel/Carousel.jsx